import { trackMixpanelEvent } from 'src/Services/Mixpanel';
import { trackExportRequested } from 'src/Services/Mixpanel/events';

/**
 * Matomo analytics tracking utilities
 *
 * This module provides functions for tracking events and interactions
 * in Matomo analytics.
 */

/**
 * Track an event in Matomo + Mixpanel
 * @param category - Event category (e.g., "Checklist", "Contact", "User")
 * @param action - Event action (e.g., "Creation", "Update", "Delete")
 * @param name - Optional name of the event (e.g., item name, title)
 * @param value - Optional numerical value associated with the event
 */
export const trackEvent = (
  category: string,
  action: string,
  name?: string,
  value?: number
): void => {
  if (window._paq) {
    window._paq.push(['trackEvent', category, action, name, value]);
  }

  trackMixpanelEvent(`${category} - ${action}`, {
    category,
    action,
    ...(name ? { name } : {}),
    ...(value !== undefined ? { value } : {}),
  });

  // Mirror to standardised snake_case events when applicable (cf. Mixpanel guide)
  if (category === 'Export' && action === 'create' && name) {
    trackExportRequested({ export_type: name });
  }
};

let matomoInitialized = false;

export function initializeMatomo(): void {
  if (matomoInitialized) {
    console.log('[Consent] Matomo is already initialized.');
    return;
  }

  const _paq = (window._paq = window._paq ?? []);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  (function () {
    const u = '//matomo.share-heritage.com/';
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', '1']);
    const d = document,
      g = d.createElement('script'),
      s = d.getElementsByTagName('script')[0];
    g.async = true;
    g.src = u + 'matomo.js';
    if (s && s.parentNode) {
      s.parentNode.insertBefore(g, s);
    } else {
      d.head.appendChild(g);
    }
  })();

  matomoInitialized = true;
  console.log('[Consent] initialized Matomo.');
}
